import { render, staticRenderFns } from "./SalesforceSettings.vue?vue&type=template&id=42934cce&"
import script from "./SalesforceSettings.vue?vue&type=script&lang=js&"
export * from "./SalesforceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports